// extracted by mini-css-extract-plugin
export default {"container":"styles__container___s9AVl","plus":"styles__plus___PpcpZ","clip":"styles__clip___-D6dX"};